<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header"><i class="fa fa-info fa-fw"></i>Sobre</h1>
          

          <p>Sistema para gestão de documentos versão <b>{{config.version}}</b> de  <b>{{config.versionDate}}</b></p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import config from "@/mixins/config.js"

export default {
  name: "About",
  data() {
    return {
      config: config,
    };
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/About.vue